import arrayUtils from 'tradera-apps/syi/script/app_react/utils/array-utils';
import 'underscore';

var initialState = null;

export default (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case 'SET_DRAFTS':
            if (action.payload) {
                state = arrayUtils.shallowCopyArrayObjects(action.payload);
            } else {
                state = null;
            }
            break;
    }
    return state;
};
